/*
  Faltu — quick view bootstrap

  The quick-view modal fills itself by assigning HTML fetched from the product
  page. Browsers deliberately do not run <script> elements inserted that way, so
  every inline script inside the product section — the media gallery's colour
  filter and "view all photos" toggle, and any merchant Custom Liquid block —
  arrives dead. Styles are unaffected: <style> injected as HTML does apply.

  This watches the modal and re-runs those scripts by swapping each one for a
  fresh element IN PLACE, so document.currentScript still resolves and the
  gallery's `document.currentScript.closest('product-media-gallery')` keeps
  working. Custom elements need no help — they upgrade on insertion, provided
  their class is defined, which is why the block scripts load site-wide.
*/
(function () {
  var RAN = 'faltuRan'

  function isRunnable (script) {
    if (script.dataset[RAN]) return false
    var type = (script.getAttribute('type') || '').toLowerCase()
    // JSON data islands and importmaps must never be executed
    return !type || type === 'module' || type.indexOf('javascript') !== -1
  }

  function alreadyLoaded (src) {
    var all = document.querySelectorAll('script[src]')
    for (var i = 0; i < all.length; i++) {
      if (all[i].src === src && !all[i].closest('[data-quick-view-contents]')) return true
    }
    return false
  }

  function run (container) {
    var scripts = Array.prototype.slice.call(container.querySelectorAll('script'))
    scripts.forEach(function (old) {
      if (!isRunnable(old)) return

      // an external file already on the page is loaded once, not per open
      if (old.src && alreadyLoaded(old.src)) {
        old.dataset[RAN] = 'true'
        return
      }

      var fresh = document.createElement('script')
      for (var i = 0; i < old.attributes.length; i++) {
        fresh.setAttribute(old.attributes[i].name, old.attributes[i].value)
      }
      fresh.dataset[RAN] = 'true'
      if (old.src) fresh.async = false
      else fresh.textContent = old.textContent

      // replace in place so currentScript.closest(...) still finds the block
      old.parentNode.replaceChild(fresh, old)
    })
  }

  function watch (container) {
    if (!container || container.dataset.faltuWatched) return
    container.dataset.faltuWatched = 'true'

    var pending = null
    var observer = new MutationObserver(function (mutations) {
      var added = mutations.some(function (m) { return m.addedNodes && m.addedNodes.length })
      if (!added) return
      // the modal fills in one go; coalesce so the scripts run once, after it settles
      clearTimeout(pending)
      pending = setTimeout(function () { run(container) }, 0)
    })
    observer.observe(container, { childList: true, subtree: true })

    if (container.children.length) run(container)
  }

  function boot () {
    document.querySelectorAll('product-quick-view-modal [data-quick-view-contents]').forEach(watch)
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot)
  else boot()
})()
